export const allFeatureFlags = [
  'automatedSiteVettingBadges',
  'newPrescreeningTrialsPage',
  'nextStepsNewStatusForPatientTrialMatch',
  'prescreeningSiteUserAccess',
  'showMedicalRecord',
  'showSliderWithHistogramFilter',
  'sitesCanAddExternalTrialsForPatientId',
  'siteSelectionLightHeading',
  'sponsorUsersWithAdminRoleForAlnylamTrial',
] as const;

const featureFlagNotToAutomaticallyActivateForDev = [
  'hideTrialsAndApplicationsForSiteUser',
] as const;

export type FeatureFlag =
  | (typeof allFeatureFlags)[number]
  | (typeof featureFlagNotToAutomaticallyActivateForDev)[number];

export type FeatureFlagListener = (newValue: boolean) => void;

export interface FeatureFlagsUserProperties {
  identifier: string;
  email: string | undefined;
  country: string | undefined;
  type: 'SponsorUser' | 'SiteUser' | 'InternalUser';
}

export interface FeatureFlagsService {
  get(name: FeatureFlag): boolean;

  setUserProperties(userProperties: FeatureFlagsUserProperties | null): void;

  addListener(name: FeatureFlag, listener: FeatureFlagListener): void;

  removeListener(name: FeatureFlag, listener: FeatureFlagListener): void;
}
